<template>
  <div v-if="dynamicSchedules && dynamicSchedules.length && studyData && taskDetailsObj && dynamicSchedulingService">
    <div>
      <div class="card inner-card">
        <div class="row color_666669">
          <div class="col-md-12">
            <div class="activity-info ml-7 mb-13">Dynamic Scheduling</div>
            <div class="activity-info-col" v-for="(dynamicSchedule, index) in dynamicSchedules" :key="'activity-dynamic-schedule-' + index">
              <!-- Triggers Details Starts -->
              <div class="row d-flex flex-row pb-15" v-for="(condition, c_index) in dynamicSchedule.conditions" :key="'trigger-' + c_index">
                <div class="col-md-3 pl-8">
                  <div class="Activite_Title" v-if="condition.isPrimaryCondition">
                    Event Trigger
                  </div>
                  <div class="Activite_Title" v-else>Additional Condition</div>
                  <span v-if="dynamicSchedulingService.triggers[condition.trigger]">{{ dynamicSchedulingService.triggers[condition.trigger].text }}</span>
                </div>

                <!-- For Step In Activity -->
                <div class="col-md-3 pl-40" v-if="dynamicSchedulingService.isStepInActivityCompleted(condition.trigger)">
                  <div class="Activite_Title">Activity Step</div>
                  <span class="activity-value">{{ dynamicSchedulingService.getStepInActivityStepTitle(condition) }}</span>
                </div>

                <div class="col-md-3 pl-40" v-if="dynamicSchedulingService.isStepInActivityCompleted(condition.trigger)">
                  <div class="Activite_Title">Response</div>
                  <span class="activity-value">{{ dynamicSchedulingService.changeDropdownValuesBasedOnResponseType(condition) }}</span>
                </div>

                <!-- For Participants Information -->
                <div class="col-md-9 pl-40" v-if="dynamicSchedulingService.isParticipant(condition.trigger)">
                  <div class="row">
                    <div class="col-md-4 pl-0">
                      <div class="Activite_Title pl-0">Field</div>
                      <span class="activity-value">{{ dynamicSchedulingService.triggers.Participant.field[condition.field] }}</span>
                    </div>
                    <div class="col-md-4 pl-20" v-if="condition.operator">
                      <div class="Activite_Title">Operator</div>
                      <span class="activity-value">{{ dynamicSchedulingService.triggers.Participant.operator[condition.operator] }}</span>
                    </div>
                    <div class="col-md-4 pl-20">
                      <div class="Activite_Title">
                        {{ dynamicSchedulingService.triggers.Participant.field[condition.field] }}
                      </div>
                      <span class="activity-value" v-if="condition.field === 'gender' && dynamicSchedulingService.registrationConfigDetails">{{ dynamicSchedulingService.getGenderText(condition.value) }}</span>
                      <span class="activity-value" v-else-if="condition.field === 'language'">{{ dynamicSchedulingService.getLanguageName(condition.value) }}</span>
                      <span class="activity-value" v-else-if="isDateOfBirth(condition.field)">{{ dynamicSchedulingService.getReadableDOB(condition.value) }}</span>
                      <span class="activity-value" v-else-if="condition.field === 'country'">{{ dynamicSchedulingService.getCountryName(condition.value) }}</span>
                      <span class="activity-value" v-else-if="condition.field === 'ageRange' && dynamicSchedulingService.registrationConfigDetails">{{ dynamicSchedulingService.getAgeRangeText(condition.value) }}</span>
                      <span class="activity-value" v-else>{{ condition.value }}</span>
                    </div>
                  </div>
                </div>
                <!-- Milestones completed -->
                <div class="col-md-5 pl-40" v-if="dynamicSchedulingService.isMilestoneComplete(condition.trigger)">
                  <div class="Activite_Title">Milestones</div>
                  <span class="activity-value">{{ dynamicSchedulingService.getMilestones(condition.milestones) }}</span>
                </div>
              </div>
              <!-- Triggers Details Ends -->

              <!-- Actions Details Starts -->
              <div class="row d-flex flex-row pb-15" v-for="(action, a_index) in dynamicSchedule.actions" :key="'action-' + a_index">
                <div class="col-md-3 pl-8">
                  <div class="Activite_Title">Action</div>
                  <span v-if="dynamicSchedulingService.actions[action.type]">{{ dynamicSchedulingService.actions[action.type].text }}</span>
                </div>
                <div class="col-md-3 pl-40" v-if="dynamicSchedulingService.forActionIsAddAnActivity(action.type) || dynamicSchedulingService.forActionIsRemovedAnActivity(action.type)">
                  <div class="Activite_Title">Activity</div>
                  <span class="">{{ dynamicSchedulingService.getActivityForSchedulings(action) }}</span>
                </div>
                <div class="col-md-3 pl-40" v-if="dynamicSchedulingService.forActionIsNotifySiteTeam(action.type)">
                  <div class="Activite_Title">Roles</div>
                  <span v-if="action.role.studyTeam || action.role.siteTeam">{{ dynamicSchedulingService.getSiteTeamMemberNames(action.role) }}</span>
                </div>
              </div>
              <!-- Actions Details Ends -->

              <!-- Scheduling Details Starts -->
              <div class="row d-flex flex-row pb-0" v-for="(schedule, s_index) in dynamicSchedule.scheduling" :key="'schedule-' + s_index">
                <div class="col-md-3 pl-8">
                  <div class="Activite_Title">Scheduling</div>
                  <span v-if="dynamicSchedulingService.schedulings[schedule.type]">{{ dynamicSchedulingService.schedulings[schedule.type].text }}</span>
                </div>
                <div class="col-md-3 pl-40" v-if="schedule.type === 'milestone'">
                  <div class="Activite_Title">Milestones</div>
                  <span class="">{{ dynamicSchedulingService.getMilestonesForSchedulings(schedule) }}</span>
                </div>

                <div class="col-md-3 pl-40" v-if="schedule.type === 'custom'">
                  <div class="Activite_Title">Frequency</div>
                  <span class="">{{ schedule.frequency.title }}</span>
                </div>
                <div class="col-md-3 pl-40" v-if="schedule.type === 'noOfDays'">
                  <div class="Activite_Title">In Number of Days</div>
                  <span class="">{{ schedule.days }}</span>
                </div>
              </div>
              <!-- Scheduling Details Ends -->
              <hr class="align-hr" v-show="index < dynamicSchedules.length - 1" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicSchedulingService from "@/services/dynamic-scheduling";

export default {
  name: "dynamic-scheduling-details",
  data() {
    return {
      studyData: null,
      dynamicSchedules: [],
      dynamicSchedulingService: null,
      taskDetailsObj: null
    };
  },
  props: {
    activityDetails: {
      type: Object,
      required: true,
      default: null
    },
    studyDetails: {
      type: Object
    },
    participantRegistrationConfigDetails: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  watch: {
    activityDetails: {
      deep: true,
      immediate: true,
      handler: function(newActivityDetails) {
        if (newActivityDetails) {
          this.taskDetailsObj = newActivityDetails;
          if (this.dynamicSchedulingService) {
            this.dynamicSchedulingService.taskDetails = this.taskDetailsObj;
          }
        }
        if (newActivityDetails && newActivityDetails.scheduler && newActivityDetails.scheduler.dynamicScheduling) {
          // Dynamic-schedules in Participant activities.
          this.dynamicSchedules = newActivityDetails.scheduler.dynamicScheduling;
        } else if (newActivityDetails && newActivityDetails.segmentSchedules && newActivityDetails.segmentSchedules.length > 0 && newActivityDetails.segmentSchedules[0].dynamicScheduling && newActivityDetails.segmentSchedules[0].dynamicScheduling.length > 0) {
          // Dynamic-schedules in Participant activities in case of segmentSchedules object.
          this.dynamicSchedules = newActivityDetails.segmentSchedules[0].dynamicScheduling;
        } else if (newActivityDetails && newActivityDetails.dynamicSchedule) {
          // Dynamic-schedules in Site activities.
          this.dynamicSchedules = newActivityDetails.dynamicSchedule;
        }
      }
    },
    studyDetails: {
      deep: true,
      immediate: true,
      handler: function(newInfo) {
        if (newInfo) {
          this.studyData = newInfo;
          this.dynamicSchedulingService = new DynamicSchedulingService();
          this.dynamicSchedulingService.studyDetails = this.studyData;
          this.dynamicSchedulingService.taskDetails = this.taskDetailsObj;
          this.dynamicSchedulingService.registrationConfigDetails = this.participantRegistrationConfigDetails;
        }
      }
    },
    participantRegistrationConfigDetails: {
      deep: true,
      immediate: true,
      handler: function(newData) {
        if (newData && this.dynamicSchedulingService) {
          this.dynamicSchedulingService.registrationConfigDetails = newData;
        }
      }
    }
  },
  methods: {
    isDateOfBirth(key) {
      return key === "dob" || key === "birthDate" || key === "dobWithMonthYear" || key === "dobWithYear";
    }
  }
};
</script>

<style scoped>
.inner-card {
  border: none;
  margin: 5px 0;
  border-radius: 3px !important;
  background-color: #d3dfe4;
}
.activity-info {
  margin-top: 15px;
  font-size: 14px;
  color: #000000;
}

.Activite_Title {
  line-height: 14px;
  font-weight: 600;
}
.activity-info-col .col {
  padding-left: 7px;
}
.align-hr {
  margin-bottom: 1.4rem;
}
</style>
